import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decreaseName',
    standalone: true
})
export class DecreaseNamePipe implements PipeTransform {

  transform(value: string): string {
    const nameArray = value.split(' ');
    return nameArray[0] + ' ' + nameArray[nameArray.length - 1].charAt(0) + '.'
  }

}
